export default __webpack_public_path__ + "static/media/9.5ce7b96d.jpg";